<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2023-03-21 10:28:34
 * @LastEditors: xgx
 * @LastEditTime: 2023-05-31 12:26:58
-->
<template>
  <a-spin :spinning="logoLoading">
      <div class="applay-box">
    <div v-for="item in dataList" style="margin-bottom: 30px">
      <div class="title">
        <div class="icon-title"></div>
        <div class="title-txt">{{ item.operationTime }}</div>
      </div>
      <div class="txt-box">
        <div class="txt">日志类型</div>
        <div class="txt-two">
          {{ item.type == 0 ? "提交" : item.type == 1 ? "转交" : "办理" }}
        </div>
      </div>
      <div v-if="item.type == 0" class="txt-box">
        <div class="txt">提交人</div>
        <div class="txt-two">{{ item.submitter }}</div>
      </div>
      <div v-if="item.type == 1" class="txt-box">
        <div class="txt">转交人</div>
        <div class="txt-two">{{ item.transferor }}</div>
      </div>
      <div v-if="item.type == 1" class="txt-box">
        <div class="txt">转交目标</div>
        <div class="txt-two">{{ item.transferTarget }}</div>
      </div>
      <div v-if="item.type == 2" class="txt-box">
        <div class="txt">办理状态</div>
        <div class="txt-two">
          {{
            item.status == 0 ? "待受理" : item.status == 1 ? "办理中" : "已办结"
          }}
        </div>
      </div>
      <div v-if="item.type == 2" class="txt-box">
        <div class="txt">办理单位</div>
        <div class="txt-two">{{ item.handlingUnit }}</div>
      </div>
      <div v-if="item.type == 2" class="txt-box">
        <div class="txt">备注</div>
        <div class="txt-two">{{ item.remark }}</div>
      </div>
      <div v-if="item.type == 2" class="txt-box">
        <div class="txt">操作人</div>
        <div class="txt-two">{{ item.finisher }}</div>
      </div>
    </div>
  </div>
  </a-spin>
  
</template>
<script>
import { findListLog } from "../index";
export default {
  data() {
    return {
      dataList: [],
      logoLoading:false,
    };
  },
  props: ["itemData",'isShow'],
  methods: {
     logoList(){
         this.logoLoading = true;
        findListLog({
          id: this.itemData.id,
        }).then((res) => {
          this.dataList = res.data;
          this.logoLoading = false;
        });
     }
  },
  mounted() {
    this.logoList()
  },
  watch:{
    isShow(val){
        if(val){
          this.logoList();
        }
    }
  }
};
</script>
<style lang="less" scoped>
.applay-box {
  padding: 24px;
  padding-top: 0px;
  padding-bottom: 100px;
}
.title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  .icon-title {
    width: 4px;
    height: 18px;
    border-radius: 2px;
    background-color: rgba(23, 109, 230, 1);
  }
  .title-txt {
    color: rgba(23, 109, 230, 1);
    font-size: 16px;
    font-family: HarmonyOS_Sans_SC-regular;
    margin-left: 10px;
    font-weight: 600;
  }
}
.txt {
  color: rgba(48, 49, 51, 1);
  font-size: 14px;
  font-family: HarmonyOS_Sans_SC-bold;
  font-weight: 600;
  width: 80px;
}
.txt-two {
  color: rgba(48, 49, 51, 1);
  font-size: 14px;
  font-family: HarmonyOS_Sans_SC-regular;
  width: 100%;
}
.txt-box {
  margin-bottom: 20px;
  display: flex;
}
</style>